import { render, staticRenderFns } from "./ProductComparisonDrawer.vue?vue&type=template&id=37f7b482"
import script from "./ProductComparisonDrawer.vue?vue&type=script&lang=js"
export * from "./ProductComparisonDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports